export function AppLoader({ label = '', fullScreen = true }) {
  const content = (
    <div
      className="flex flex-col items-center gap-6"
      role="status"
      aria-live="polite"
    >
      <div className="relative grid size-16 place-items-center">
        <div className="absolute inset-0 animate-loader-ring rounded-full border-[3px] border-indigo-200/70 border-t-brand-primary" />
        <div className="absolute inset-2 animate-loader-ring-slow rounded-full border-[2px] border-violet-200/50 border-b-violet-500" />
        <div className="grid size-9 place-items-center rounded-full overflow-hidden bg-white shadow-[0_8px_24px_rgba(99,102,241,0.35)]">
          <img
            src="/logo.jpeg"
            alt="Superior CRM"
            className="size-full object-contain"
          />
        </div>
      </div>
      {label ? (
        <p className="text-sm font-medium tracking-wide text-muted-foreground">
          {label}
        </p>
      ) : null}
    </div>
  )

  if (!fullScreen) return content

  return (
    <div className="fixed inset-0 z-[1400] grid place-items-center bg-surface-page">
      {content}
    </div>
  )
}
